export const navLink = [
  {
    text: "Home",
    link: "/",
    down: false,
  },
  {
    text: "Shop",
    link: "/shop",
    down: true,
  },

  {
    text: "Product",
    link: "/product",
    down: true,
  },
  {
    text: "Contact Us",
    link: "/contactus",
  },
];
